import { render } from "./TruthOrDarePrivacyPolice.vue?vue&type=template&id=16983d2b"
import script from "./TruthOrDarePrivacyPolice.vue?vue&type=script&lang=js"
export * from "./TruthOrDarePrivacyPolice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__